<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Mandatory Disclouser </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm media section-banner-bg-1">
    <div class="container">
        <div class="title-heading inner-heading text-center mb-5 shadow-text-sm">
            <h2>Mandatory <span> Disclouser</span></h2>
        </div>


        <div class="row  row-cols-1 row-cols-lg-3">
            <div class="col">
                <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/sports-cultural-foundation.pdf"
                    width="100%" height="300px" frameborder="0"></iframe>
            </div>
            <!-- <div class="col">
                <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/knowldge-foundation.pdf"
                    width="100%" height="300px" frameborder="0"></iframe>
            </div> -->
            <div class="col">
                <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/coi.pdf" width="100%"
                    height="300px" frameborder="0"></iframe>
            </div>
            <div class="col">
                <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/pan.pdf" width="100%"
                    height="300px" frameborder="0"></iframe>
            </div>
        </div>




    </div>
</section>
